import { ErrorInfo } from 'react';

export const handleError = (error: Error, info: ErrorInfo) => {
  // Do something with the error, e.g. log to an external API
  console.error(error.message);
  console.error(info);
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
};
